import React, { useCallback, useState, useEffect } from 'react';
import { Flex, Grid } from 'antd';

import useLocalStorage from '@Shared/utils/useLocalStorage';
import { SigninSteps } from '@Features/auth/signin';
import { Logo, Bg } from '@Shared/assets/images';
import { LanguageDropdown } from '@Widgets/index';

const { useBreakpoint } = Grid;

import './styles.less';

const styles: Record<string, React.CSSProperties> = {
    flex: {
        minWidth: '100vw',
        minHeight: '100vh',
        backgroundColor: '#F6F9FD',
        flexDirection: 'column',
        backgroundSize: 'cover',
    },
    main: {
        boxSizing: 'border-box',
        background: '#fff',
        height: 'fit-content',
        borderRadius: 'var(--ant-border-radius-lg)',
        position: 'relative',
    },
    languageWrapper: {
        position: 'absolute',
        zIndex: 10,
    },
    mainWrapper: {
        width: '100%',
        justifyContent: 'center',
        overflow: 'auto',
        flex: 1,
        alignItems: 'center',
        padding: 20,
        position: 'relative',
    },
    buttons: {
        position: 'fixed',
        left: '10px',
        bottom: '10px',
    },
    topLogo: {
        width: 162,
        marginRight: 'auto',
    },
    header: {
        display: 'flex',
        justifyContent: 'center',
        // top: 0,
        height: '80px',
        width: '100%',
        backgroundColor: 'inherit',
        borderBottom: '1px solid #8DB4E11A',
        zIndex: 5,
    },
    headerInner: {
        display: 'flex',
        alignItems: 'center',
        height: '80px',
        width: '100%',
        backgroundColor: 'inherit',
        maxWidth: 'min(calc(100vw - 20px), 1400px)',
    },
};

type StepType = keyof typeof SigninSteps;
const stepsKeys: StepType[] = ['AuthStep', 'CompanyStep', 'TrialStep'];

export default function Signin() {
    const breakpoints = useBreakpoint();
    const storage = useLocalStorage();
    const [currentStep, setCurrentStep] = useState<StepType>(storage.read('currentStep', stepsKeys[0]) as StepType);
    const isCurrentAuthStep = currentStep === 'AuthStep';

    const handleStep = useCallback(
        async (direction: number) => {
            const currentStepIndex = stepsKeys.findIndex((value: string) => value === currentStep);
            const tmpStepIndex = currentStepIndex + direction;
            const newStepIndex =
                tmpStepIndex < 0 ? stepsKeys.length - 1 : tmpStepIndex === stepsKeys.length ? 0 : tmpStepIndex;
            setCurrentStep(stepsKeys[newStepIndex]);
        },
        [currentStep],
    );

    useEffect(() => {
        document.getElementById('scroll-flex')?.scroll(0, 0);
    }, [currentStep]);

    const CurrentForm = SigninSteps[currentStep];

    const header = isCurrentAuthStep ? (
        <div style={styles.header}>
            <div style={{ ...styles.headerInner, margin: breakpoints.lg ? 'auto' : '0 20px' }}>
                <img
                    src={Logo}
                    style={styles.topLogo}
                    alt="Tapfiliate"
                />

                <LanguageDropdown />
            </div>
        </div>
    ) : null;

    const displayBackgroundImage = !isCurrentAuthStep && breakpoints.lg;

    return (
        <Flex
            justify="center"
            align="center"
            style={{ ...styles.flex, backgroundImage: displayBackgroundImage ? `url(${Bg})` : 'unset' }}
        >
            {header}
            <Flex
                style={styles.mainWrapper}
                id="scroll-flex"
            >
                <div style={{ ...styles.main, margin: breakpoints.lg ? 'auto' : 'auto 20px' }}>
                    {!isCurrentAuthStep && (
                        <div
                            style={{
                                ...styles.languageWrapper,
                                top: breakpoints.lg ? '40px' : '20px',
                                right: breakpoints.lg ? '60px' : '20px',
                            }}
                        >
                            <LanguageDropdown />
                        </div>
                    )}
                    <CurrentForm handleStep={handleStep} />
                </div>
            </Flex>
        </Flex>
    );
}
